<template>
  <vue-final-modal
    :value="visible"
    name="ai-mypr-dialog"
    :classes="['ai-mypr-dialog__container']"
    :content-class="[
      'ai-mypr-dialog__shell',
      'v--modal-box',
      'v--modal',
      'ai-mypr-modal',
      'ai-mypr-modal-sheet'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="onInput"
    @before-close="onBeforeClose"
  >
    <slot />
  </vue-final-modal>
</template>

<script setup lang="ts">
/**
 * 書式編集の AI mypr ダイアログ殻（VFM）。
 * 開閉は親の `visible`（`:visible` + `@update:visible`）。中身は親の slot。
 * 遠い close は親の useAiMyprDialogControls が mitt HIDE を購読する。
 * 注: Vue 2 ESLint（valid-v-model）が `v-model:arg` を拒否するため、明示バインドを使う。
 *
 * 配置: PC 中央 / sm ボトムシート（旧 vue-js-modal + ai-mypr-modal-sheet 相当）。
 * VFM では :styles flex を使わず __container で制御する。
 */
defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
  (e: 'input', value: boolean): void
  (e: 'before-close'): void
}>()

function onInput(value: boolean) {
  emit('update:visible', value)
  emit('input', value)
  if (!value) emit('before-close')
}

function onBeforeClose() {
  emit('before-close')
}
</script>

<!--
  content-class / classes は VFM 内部ノードのため non-scoped。
  旧 .ai-mypr-modal-sheet の ::v-deep .v--modal-overlay は VFM に効かないため、
  配置・寸法はここに直書きする。
-->
<style lang="scss">
@import '@/assets/scss/variables';

.ai-mypr-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @include max-width(sm) {
    align-items: flex-end;
    padding: 0;
  }
}

.ai-mypr-dialog__shell.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  width: 100%;
  max-width: 560px;
  max-height: 85vh;
  margin-block: auto;
  overflow: hidden;
  border-radius: 16px;
  padding: 20px;
  left: 0 !important;

  @include max-width(sm) {
    margin-block: 0;
    max-width: 100%;
    border-radius: 16px 16px 0 0;
  }
}
</style>
